import React, { useState, useEffect, useRef } from 'react';
import { ContentPopup } from 'components/ContentPopup.jsx';
import PostRequest from 'components/common/PostRequest.jsx';

const SolutionDimensions = ( { type, solution } ) => {
  // an example of solution object can be seen on /Users/emre/code/boxes/data/examples/solution.json

  const userUnit = window.user_unit;
  const [showDimensions, setShowDimension] = useState(false);
  const [presentedLayoutOptions, setPresentedLayoutOptions] = useState({});

  const getNumXPrinting = () => {
    if (type !== "printing") return;
    return solution?.diecutting_result?.printing_result?.num_x || 0;
  }

  const getNumXDiecutting = () => {
    if (type !== "diecutting") return;
    return solution?.diecutting_result?.num_x || 0;
  }

  const getNumYPrinting = () => {
    if (type !== "printing") return;
    return solution?.diecutting_result?.printing_result?.num_y || 0;
  }

  const getNumYDiecutting = () => {
    if (type !== "diecutting") return;
    return solution?.diecutting_result?.num_y || 0;
  }

  const getNumX = () => {
    const printingValue = getNumXPrinting();
    const dieCuttingValue = getNumXDiecutting();

    if (printingValue !== undefined) return printingValue;
    if (dieCuttingValue !== undefined) return dieCuttingValue;

    throw new Error(`Unsupported type: ${type}. Expected 'printing' or 'diecutting'.`);
  }

  const getNumY = () => {
    const printingValue = getNumYPrinting();
    const dieCuttingValue = getNumYDiecutting();

    if (printingValue !== undefined) return printingValue;
    if (dieCuttingValue !== undefined) return dieCuttingValue;

    throw new Error(`Unsupported type: ${type}. Expected 'printing' or 'diecutting'.`);
  }

  const getNumTotalPrinting = () => {
    if (type !== "printing") return;
    return solution?.num_total_printing || 0;
  }

  const getNumTotalDiecutting = () => {
    if (type !== "diecutting") return;
    return solution?.num_total_diecutting || 0;
  }

  const getNumTotal = () => {
    if (type === "printing")   { return getNumTotalPrinting(); }
    if (type === "diecutting") { return getNumTotalDiecutting(); }

    throw new Error(`Unsupported type: ${type}. Expected 'printing' or 'diecutting'.`);
  }

  const [numX, setNumX] = useState(getNumX)
  const [numY, setNumY] = useState(getNumY)
  const [numTotal, setNumTotal] = useState(getNumTotal)
  const [outputXLength, setOutputXLength] = useState("")
  const [outputYLength, setOutputYLength] = useState("")
  const [efficiency, setEfficiency] = useState("")

  useEffect( () => {
    console.log({solution})
  }, [])

   useEffect( () => {
    if(type == "printing") { return; }

    setOutputXLength( () => presentedLengthValueInUserUnit(solution.diecutting_result.calculated_output_dimensions.output_x_length) )
    setOutputYLength( () => presentedLengthValueInUserUnit(solution.diecutting_result.calculated_output_dimensions.output_y_length) )

    if(solution.diecutting_result.efficiency !== undefined) {
      setEfficiency( () => `${solution.diecutting_result.efficiency}%` )
    }
   }, [])


   const presentedLengthValueInUserUnit = (value_in_mm) => {
    if (userUnit === "in" || userUnit == "infr") {
      const valueInInches = parseFloat(value_in_mm) / 25.4;
      return `${valueInInches.toFixed(4)} in`;
    } else {
      return `${parseFloat(value_in_mm).toFixed(2)} mm`;
    }
   }

   useEffect( () => {
    if(type == "printing") { return; }

    setNumX( () => solution.diecutting_result.num_x )
    setNumY( () => solution.diecutting_result.num_y )
   }, [])

  const getContentForPresentedOptions = () => {
    const url = `/manufacturing-cost-calculator/${window.drawing_id}/${window.drawing_slug}/${window.user_quote_id}/presented_layout_dimensions/${type}`;
    setContentForPresentedOptions( () => "" )

    PostRequest({
      url: url,
      data: {
        solution: solution
      },
      callback: (response) => {

      const layoutAnnotations = response.layout_annotations;
      const layoutAnnotationsTitle = response.layout_annotations_title;

      const layoutTableRows = Object.entries( layoutAnnotations )
        .map(([key, value]) => key != value ? `<tr><td><strong>${key}</strong></td><td>${value}</td></tr>` : `<tr><td colspan="2"><strong>${key}</strong></td> </tr>`)
        .join('');

      setPresentedLayoutOptions( () => window.user_quote.presented_dieline_options );

      const dielinesTableRows = Object.entries( window.user_quote.presented_dieline_options )
        .map(([key, value]) => `<tr><td><strong>${key}</strong></td><td>${value}</td></tr>`)
        .join('');

      const htmlContent = `
        <br /> <h4> ${layoutAnnotationsTitle} </h4> <br />  <br />
        <table class="table table-striped">
          <tbody>
            ${layoutTableRows}
          </tbody>
        </table>

        <br /> <h4> ${ t('quote_builder.dielines') } </h4> <br />  <br />
        <table class="table table-striped">
          <tbody>
            ${dielinesTableRows}
          </tbody>
        </table>
      `;

      const content = <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
      setContentForPresentedOptions( () => content );

      }
    })



  }

  const [contentForPresentedOptions, setContentForPresentedOptions] = useState(<div> Loading... </div>);
  const showDimensionsContentPopupRef = useRef();
  const showDimensionsContentPopup = () => {
    let callback = () => {
      showDimensionsContentPopupRef.current.style.display = "none";
      setShowDimension(false);
    };

    let response = <ContentPopup myRef={showDimensionsContentPopupRef} autoOpen={true} content={contentForPresentedOptions} cancelButton={false} beforeClose={callback} />;

    return response;
  };

  useEffect(() => {
    if(showDimensions) {
      getContentForPresentedOptions();
    }
  }, [showDimensions])

  return (<>
    <table className="table table-bordered">
    <tbody>

      {type == "diecutting" && outputXLength != "" && (
        <tr>
          <td>
            <span className="arrow"><i className="fa fa-arrows-h" aria-hidden="true"></i></span>
            <span className="info-quote">  {outputXLength} </span>
          </td>
          <td>
            <span className="arrow"><i className="fa fa-arrows-v" aria-hidden="true"></i></span>
            <span className="info-quote">  {outputYLength}  </span>
          </td>

        </tr>
       )}

       {type == "diecutting" && efficiency != "" && (
        <tr>
          <td colSpan="2">
            <span className="info-quote">Efficiency: {efficiency}</span>
          </td>
        </tr>
       )}

       <tr>

        <td>
          {numX && <span className="info-quote">
          {(numTotal == undefined || numX * numY == numTotal) && <> ({numX} x {numY}) </> }
          {numTotal != undefined && numX * numY != numTotal && <>  &nbsp; ({numTotal}) </> }
          &nbsp;  &nbsp; </span> }
        </td>
        <td> <button className="btn btn-default" onClick={() => setShowDimension(true)}> Show dimensions</button>  </td>
      </tr>


    </tbody>
    </table>
    {showDimensions && showDimensionsContentPopup()}
    </>);
}

export default SolutionDimensions;
